import { render, staticRenderFns } from "./theme-picker.vue?vue&type=template&id=3288e678"
import script from "./theme-picker.vue?vue&type=script&lang=js"
export * from "./theme-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3288e678')) {
      api.createRecord('3288e678', component.options)
    } else {
      api.reload('3288e678', component.options)
    }
    module.hot.accept("./theme-picker.vue?vue&type=template&id=3288e678", function () {
      api.rerender('3288e678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/components/layout/theme-picker/theme-picker.vue"
export default component.exports